import { render, staticRenderFns } from "./index.vue?vue&type=template&id=df7fde30&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df7fde30",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/suifeng/Desktop/projects/2023/thShop/thShopAdmin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('df7fde30')) {
      api.createRecord('df7fde30', component.options)
    } else {
      api.reload('df7fde30', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=df7fde30&scoped=true&", function () {
      api.rerender('df7fde30', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/setting/algoCreator/index.vue"
export default component.exports